// extracted by mini-css-extract-plugin
module.exports = {"btn":"style_btn__28NEe","row":"style_row__1Znei","title":"style_title__iKmlB","outlined":"style_outlined__2quK2"};